import { AnalyticsContext } from "@/Contexts/AnalyticsContext";
import { CookieManagerContext } from "@/Contexts/CookieManagerContext";
import { listenToAppEvent, sendEventToApp } from "@/utils/appCommunication";
import { PropsWithChildren, useContext, useEffect } from "react";

export function MobileAppTracking({ children }: PropsWithChildren) {
    const { saveCookieSettingsAndCloseAll } = useContext(CookieManagerContext);
    const analytics = useContext(AnalyticsContext);

    useEffect(() => {
        const unsubscribeFromTrackingStatus = listenToAppEvent(
            "setTrackingStatus",
            (canTrack) => {
                saveCookieSettingsAndCloseAll(
                    {
                        analytics: true,
                        advertising: canTrack,
                    },
                    analytics,
                );
            },
        );
        sendEventToApp("requestTracking", {});

        return () => unsubscribeFromTrackingStatus();
    }, []);

    useEffect(() => {
        return listenToAppEvent(
            "pushNotificationOpened",
            ({ notificationType, path }) => {
                analytics.trackEvent("push_notification_opened", {
                    notification_type: notificationType ?? "unknown",
                    path,
                });
            },
        );
    }, [analytics]);

    return children;
}
